module.exports = __webpack_public_path__ + "static/media/bullet-inscriere-activa.8ab175c7.png";